/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Statscountin24h2Inputs */

const en_statscountin24h2 = /** @type {(inputs: Statscountin24h2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} in 24 h`)
};

const de_statscountin24h2 = /** @type {(inputs: Statscountin24h2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} in 24 Std.`)
};

/**
* | output |
* | --- |
* | "{count} in 24 h" |
*
* @param {Statscountin24h2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statscountin24h2 = /** @type {((inputs: Statscountin24h2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statscountin24h2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statscountin24h2(inputs)
	return de_statscountin24h2(inputs)
});
export { statscountin24h2 as "statsCountIn24h" }